import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, err: any) => {
        // Don't retry on 401/403/422
        const status = err?.response?.status;
        if (status === 401 || status === 403 || status === 422) return false;
        return failureCount < 2;
      },
    },
  },
});
